/* gumee video hero: play once, then hold the final frame.
   Reduced motion: skip playback, show the final frame image. */
class GumeeHeroVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      this.dataset.mode = 'still';
      return;
    }

    this.dataset.mode = 'play';
    this.video.src = this.dataset.videoSrc;
    this.video.addEventListener('ended', () => {
      // Swap to the crisp end-frame image once playback settles
      this.dataset.mode = 'still';
    });
    this.video.play().catch(() => {
      // Autoplay blocked: fall back to the still image
      this.dataset.mode = 'still';
    });
  }
}

if (!customElements.get('gumee-hero-video')) {
  customElements.define('gumee-hero-video', GumeeHeroVideo);
}
